import { supabase } from "../services/supabaseClient";
import { getEmpresaId } from "./sessionService";

function calcularColoresEvento(fechaProxima) {
  if (!fechaProxima) {
    return {
      backgroundColor: "#475569",
      borderColor: "#475569",
    };
  }

  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);

  const fecha = new Date(`${fechaProxima}T00:00:00`);
  fecha.setHours(0, 0, 0, 0);

  const diferenciaMs = fecha - hoy;
  const diasRestantes = Math.ceil(diferenciaMs / (1000 * 60 * 60 * 24));

  if (diasRestantes < 0) {
    return {
      backgroundColor: "#dc2626",
      borderColor: "#dc2626",
    };
  }

  if (diasRestantes <= 30) {
    return {
      backgroundColor: "#d97706",
      borderColor: "#d97706",
    };
  }

  return {
    backgroundColor: "#059669",
    borderColor: "#059669",
  };
}

export const obtenerFechasCalibracion = async () => {
  const empresa_id = getEmpresaId();

  const { data, error } = await supabase
    .from("instrumentos")
    .select("id, nombre, identificacion, fecha_proxima, ubicacion, certificado, activo")
    .eq("activo", true)
    .eq("empresa_id", empresa_id)
    .abortSignal(AbortSignal.timeout(8000));

  if (error) {
    throw new Error(`Calendario: ${error.message}`);
  }

  const instrumentos = data || [];

  const eventos = instrumentos
    .filter((instrumento) => instrumento.fecha_proxima)
    .map((instrumento) => {
      const colores = calcularColoresEvento(instrumento.fecha_proxima);

      return {
        id: instrumento.id,
        title: `${instrumento.identificacion} - ${instrumento.nombre}`,
        start: instrumento.fecha_proxima,
        allDay: true,
        backgroundColor: colores.backgroundColor,
        borderColor: colores.borderColor,
        extendedProps: {
          ubicacion: instrumento.ubicacion || "Sin ubicación",
          asignado: "Sin asignar",
          certificado: instrumento.certificado || "Sin certificado",
        },
      };
    });

  return {
    instrumentos,
    eventos,
  };
};